import { forEach } from "lodash";

import setGroupingWithCalculatedSumTotals from "./setGroupingWithCalculatedSumTotals";

export default (groupings, columns) => {
  forEach(groupings, (grouping) => {
    setGroupingWithCalculatedSumTotals(grouping, columns);
  });
};
